const mobileMenuBtn = document.getElementById( 'burgerIcon' ),
	mobileMenu = document.getElementById( "mobileMenuCnt" ),
	mobileOverlay = document.getElementById( "mobileOverlay" );


mobileMenuBtn.addEventListener( "click", e => {
	e.preventDefault()
	e.stopImmediatePropagation()
	toggleMenu();
} )

mobileOverlay.addEventListener( "click", e => {
	e.preventDefault()
	e.stopImmediatePropagation()
	toggleMenu();
} )

function toggleMenu() {
	if ( mobileMenu.classList.contains( "isActive" ) ) {
		mobileMenu.classList.remove( "isActive" )
		mobileOverlay.classList.remove( "isActive" )
	}
	else {
		mobileOverlay.classList.add( "isActive" )
		mobileMenu.classList.add( "isActive" )
	}
}



/* CONTACT FORM RELATED */
export const validateFuncs = {
	validateEmail
}

function validateEmail( mail ) {
	return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( mail )
}

export function hightlightErr( fieldEl, fieldName, msg ) {
	const spanMsg = document.getElementById( 'inputMsg' );
	const spanId = `${fieldName}Err`

	/* if invalid class exists just replace text do not add further span */
	if ( fieldEl.classList.contains( "is-invalid" ) ) {
		const spanMsg = document.getElementById( spanId )
		spanMsg.innerHTML = ""
		const newText = document.createTextNode( msg )
		spanMsg.append( newText )
		return;
	}

	/* create new span to show */
	const newSpanMsg = spanMsg.cloneNode()
	newSpanMsg.setAttribute( 'id', spanId )
	const invalidText = document.createTextNode( msg )
	newSpanMsg.append( invalidText )

	/* add invalid class */
	fieldEl.classList.add( "is-invalid" )
	newSpanMsg.classList.add( "is-invalid" )

	fieldEl.parentNode.insertBefore( newSpanMsg, fieldEl )
}

export function unhighlightErr( fieldEl, fieldName ) {
	if ( !fieldEl.classList.contains( "is-invalid" ) )
		return;

	const msgEl = document.getElementById( `${fieldName}Err` )
	msgEl.remove()

	fieldEl.classList.remove( "is-invalid" )
}

export function displayMsg( type ) {
	const msgResponses = document.getElementById( "msgResponses" );

	msgResponses.innerHTML = ""
	if ( type === "" ) return

	msgResponses.append( document.createTextNode( msgResponses.dataset?.[ type ] ?? "" ) )
}

